import React, { Fragment } from 'react'
import { RiscoTable } from './RiscoTable'
import { RiscoFilter } from './RiscoFilter'

export const RiscoList = ({ classes, ...props }) => {
  return (
    <Fragment>
      <RiscoFilter />
      <RiscoTable classes={classes} props={props} />
    </Fragment>
  )
}
